import InputSerial from './InputSerial.jsx';

export default InputSerial;